import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, catchError, tap, filter, take } from 'rxjs/operators';

import { getIsAdminUser, GetIsAdminUser } from '../../state-management';

import { of } from 'rxjs';

@Injectable()
export class AdminGuard  {

    constructor(private store: Store<{}>) {
    }

    canActivate(): Observable<boolean> {

        return this.checkStore().pipe(
            switchMap((res) => of(res)),
            catchError(() => of(false))
        );
    }

    checkStore(): Observable<boolean> {

        return this.store.select(getIsAdminUser)
            .pipe(
                tap((data: any) => {
                    if (data === null || data.admin === null) {
                        this.store.dispatch(new GetIsAdminUser());
                    }
                }),
                filter((data: any) => {
                    if (data) {
                        return data;
                    }
                }),
                take(1)
            )
    }


}
